Prism.languages.hsts = {
  directive: {
    pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
    alias: "property"
  },
  operator: /=/,
  punctuation: /;/
};